import { envBasics } from 'src/environments/dvds/basics';
import { Environment } from '../../app/environment';

export const environment: Environment = {
    ...envBasics,
    apiEndpoint: 'https://planning-test.dvds.nl/api/',
    disableAfas: true,
    feEndpoint: 'https://planning-test.dvds.nl/',
    dirkAppUrl: 'https://dirk-test.dvds.nl/',
    production: true,
    test: true,
    titleAppend: ' - TEST - D. van der Steen B.V.',
    wsEndpoint: 'wss://planning-test.dvds.nl/websocket/',
};
